import { render, staticRenderFns } from "./revocationDialog.vue?vue&type=template&id=fbbfdc66&scoped=true"
import script from "./revocationDialog.vue?vue&type=script&lang=js"
export * from "./revocationDialog.vue?vue&type=script&lang=js"
import style0 from "./revocationDialog.vue?vue&type=style&index=0&id=fbbfdc66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbfdc66",
  null
  
)

export default component.exports